import { render, staticRenderFns } from "./home3Dian5.vue?vue&type=template&id=83d66782&scoped=true"
import script from "./home3Dian5.vue?vue&type=script&lang=js"
export * from "./home3Dian5.vue?vue&type=script&lang=js"
import style0 from "./home3Dian5.vue?vue&type=style&index=0&id=83d66782&prod&lang=css"
import style1 from "./home3Dian5.vue?vue&type=style&index=1&id=83d66782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d66782",
  null
  
)

export default component.exports